const Home = () => import("../pages/Home.vue");
const MisCursos = () => import("../pages/MisCursos.vue");
const PerfilSettings = () => import("../pages/PerfilSettings.vue");
const Categories = () => import("../pages/Categories.vue");
const Facturacion = () => import("../pages/Facturacion.vue");
const CourseDetail = () => import("../pages/CourseDetail.vue");
const ProductCourse = () => import("../pages/ProductCourse.vue");
const CartBuy = () => import("../pages/CartBuy.vue");
const PaymentInfo = () => import("../pages/PaymentInfo.vue");
const Mentories = () => import("../pages/Mentories.vue");
const Maker = () => import("../pages/Maker.vue");

const routes = [
  {
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
    path: "/v2/home",
    component: Home,
    name: "homev2",
    children: [
      {
        path: "/v2/home",
        component: MisCursos,
        name: "v2-misCursos",
      },
      {
        path: "/v2/settings",
        component: PerfilSettings,
        name: "v2-profile",
      },
      {
        path: "/v2/facturacion",
        component: Facturacion,
        name: "v2-facturacion",
      },
      {
        path: "/v2/courses/:id/:resource?",
        component: CourseDetail,
        name: "v2-course-detail",
      },
      {
        path: "/v2/product/:id?",
        component: ProductCourse,
        name: "v2-product-course",
      },
      {
        path: "/v2/cart",
        component: CartBuy,
        name: "v2-cart-buy",
      },
      {
        path: "/v2/categories/:id?",
        component: Categories,
        name: "v2-categories",
      },
      {
        path: "/v2/payment-info",
        component: PaymentInfo,
        name: "payment-info",
      },
      {
        path: "/v2/mentories/:id",
        component: Mentories,
        name: "v2-mentories",
      },
    ],
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("a_t")) {
        next();
      } else {
        localStorage.clear();
        next(`/login`);
      }
    },
  },
  {
    path: "/v2/maker",
    component: Maker,
    name: "v2-maker"
  }
];


export default routes;
